import APIClient from './index';
import _ from 'lodash';
import { toApiError } from './api_error';

export const getEvaluations = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error') || _.get(err, 'data.msg') || _.get(err, 'message') || 'Queue request failed.'));
  });
};

export const getLiveSummary = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/live-summary', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getReadiness = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/readiness', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getCatalogDuplicates = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/catalog-duplicates', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOpportunities = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/opportunities', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getOpportunityLinks = (Opportunity_id, params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/UrlDataAgentEvaluations/opportunities/${Opportunity_id}/links`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const getCreationRequestBatches = (params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/creation-requests', { params })
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const parkCreationRequestPins = body => {
  return new Promise((resolve, reject) => {
    APIClient.post('/UrlDataAgentEvaluations/creation-requests', body)
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const getCreationRequestLinks = (tag, params = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/UrlDataAgentEvaluations/creation-requests/${encodeURIComponent(tag)}/links`, { params })
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const approveCreationRequests = (tag, body) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/creation-requests/${encodeURIComponent(tag)}/approve`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const overrideCreationRequest = (tag, body) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/creation-requests/${encodeURIComponent(tag)}/override`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const stopCreationRequests = (tag, body) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/creation-requests/${encodeURIComponent(tag)}/stop`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const undoCreationRequest = (tag, body) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/creation-requests/${encodeURIComponent(tag)}/undo`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(toApiError(err)));
  });
};

export const getEvaluation = id => {
  return new Promise((resolve, reject) => {
    APIClient.get(`/UrlDataAgentEvaluations/${id}`)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const applyEvaluation = (id, body = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/${id}/apply`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const sendEvaluationToHuman = (id, body = {}) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/${id}/send-to-human`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const correctEvaluation = (id, body) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/${id}/correct`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const confirmEvaluationMatch = (id, body) => {
  return new Promise((resolve, reject) => {
    APIClient.post(`/UrlDataAgentEvaluations/${id}/confirm-match`, body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error') || _.get(err, 'message') || 'Match confirmation failed.'));
  });
};

export const getApplyMode = () => {
  return new Promise((resolve, reject) => {
    APIClient.get('/UrlDataAgentEvaluations/apply-mode')
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const setApplyMode = body => {
  return new Promise((resolve, reject) => {
    APIClient.put('/UrlDataAgentEvaluations/apply-mode', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};

export const setApplyThreshold = body => {
  return new Promise((resolve, reject) => {
    APIClient.put('/UrlDataAgentEvaluations/apply-mode/threshold', body)
      .then(response => resolve(response.data))
      .catch(err => reject(_.get(err, 'data.error')));
  });
};
